<template>
<div>
    <p class="list-badge" v-if="materialData && materialData.isPackage">
      <span class="badge">{{$t('INDENT_WEIGHT')}}</span>
      <label>
        <template
          v-if="materialData.weight"
        >{{fixTwoDigits(materialData.weight.value)}} {{materialData.weight.unit}}</template>
        <template v-else>0</template>
      </label>
      <span class="badge">{{$t('INDENT_VOLUME')}}</span>
      <label>
        <template
          v-if="materialData.volume"
        >{{fixTwoDigits(materialData.volume.value)}} {{materialData.volume.unit}}</template>
        <template v-else>0</template>
      </label>
      <span class="badge">{{$t('INDENT_QUANTITY')}}</span>
      <label>
        <template v-if="materialData.quantity">
          <span v-if="materialData.quantity.value">
            {{fixTwoDigits(
            materialData.quantity.value
            )}}
            {{materialData.quantity.unit}}
          </span>
        </template>
        <template v-else>0</template>
      </label>
    </p>
    <div class="position-relative" :class="getTableClass">
      <div class="action-fixed-table">
        <a href="javascript:;"
          @click="handlePrev(index);$addGAEvent('Indent Management','Click','Documents:Material Section Scroll')"
          class="slide-leftarrow"
        >
          <i class="arrow left pointer"></i>
        </a>
        <a href="javascript:;"
          @click="handleNext(index);$addGAEvent('Indent Management','Click','Documents:Material Section Scroll')"
          class="slide-rightarrow"
        >
          <i class="arrow right pointer"></i>
        </a>
      </div>
      <Table
        highlight-current-row :data="materialsList" max-height="244" class="table-fixed expand-icon"
        ref="tableref"
        stripe
        border
        row-key="id"
        lazy
        :load="load"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @header-dragend="getDepotDetailParameters"
        editable="right"
        @cell-click="currentCell"
        aria-describedby="materialDetailsTableData"
      >
        <Table-column
          fixed
          :resizable="false"
          :label="materialHeaders.material_ref_id"
          width="145">
          <template slot-scope="material">
              <div class="left-value">
                  <span>
                    <Ellipsis v-bind:text="material.row.material_ref_id" :length="10" />
                  </span>
                  <epod-comment
                    v-if="canShowGrn"
                    :canShowGrn="canShowGrn"
                    :comment="material.row.epod.comment"
                    :material="material.row"
                    :orderNumber="orderDetails.order_number"
                  >
                  </epod-comment>
                  <span class="action-hover" v-permission="['indent_add_materials']"
                  v-if="!hasMaterialInvoice && !isDispatched">
                    <svgicon name="icon-delete-md" class="pointer" width="14" height="14" @click="confirmDeleteMaterial(material.row)"/>
                  </span>
              </div>
          </template>
        </Table-column>
        <Table-column prop="materialCode" :label="materialHeaders.material_code" :width="getWidth('tableref','materialCode') ? getWidth('tableref','materialCode') : 150" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.material_code}}</div>
              <div class="text-ellipsis pointer">{{material.row.material_code}}</div>
            </Tooltip>
            <!-- <Ellipsis
              :text="material.row.material_code"
              :length="10" /> -->
          </template>
        </Table-column>
        <Table-column prop="materialName" :label="$t('MATERIAL_NAME')" :width="getWidth('tableref','materialName') ? getWidth('tableref','materialName') : 120" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.material_name}}</div>
              <div class="text-ellipsis pointer">{{material.row.material_name}}</div>
            </Tooltip>
          </template>
        </Table-column>
        <Table-column prop="quantity" :label="materialHeaders.quantity" :width="getWidth('tableref','quantity') ? getWidth('tableref','quantity') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{fixTwoDigits(material.row.quantity.value)}} {{material.row.quantity.unit}}</div>
              <div class="text-ellipsis pointer">{{fixTwoDigits(material.row.quantity.value)}} {{material.row.quantity.unit}}</div>
            </Tooltip>
            <!-- <Ellipsis
              v-bind:text="`${material.row.quantity.value} ${material.row.quantity.unit}`"
              :length="10"
            /> -->
          </template>
        </Table-column>
        <Table-column v-if="materialHeaders.previous_leg_quantity" prop="actual_quantity" :label="materialHeaders.previous_leg_quantity" :width="getWidth('tableref','quantity') ? getWidth('tableref','quantity') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{(material.row.previous_leg_quantity && material.row.previous_leg_quantity.value) || 0}} {{material.row.previous_leg_quantity && material.row.previous_leg_quantity.unit}}</div>
              <div class="text-ellipsis pointer">{{(material.row.previous_leg_quantity && material.row.previous_leg_quantity.value) || 0}} {{material.row.previous_leg_quantity && material.row.previous_leg_quantity.unit}}</div>
            </Tooltip>
          </template>
        </Table-column>
        <Table-column prop="weight" :label="materialHeaders.weight" :width="getWidth('tableref','weight') ? getWidth('tableref','weight') : 100" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{fixTwoDigits(material.row.weight.value)}} {{material.row.weight.unit}}</div>
              <div class="text-ellipsis pointer">{{fixTwoDigits(material.row.weight.value)}} {{material.row.weight.unit}}</div>
            </Tooltip>
            <!-- <Ellipsis
              v-bind:text="`${material.row.weight.value} ${material.row.weight.unit}`"
              :length="10"
            /> -->
          </template>
        </Table-column>
        <Table-column prop="volume" :label="materialHeaders.volume" :width="getWidth('tableref','volume') ? getWidth('tableref','volume') : 100" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{fixTwoDigits(material.row.volume.value)}} {{material.row.volume.unit}}</div>
              <div class="text-ellipsis pointer">{{fixTwoDigits(material.row.volume.value)}} {{material.row.volume.unit}}</div>
            </Tooltip>
            <!-- <Ellipsis
              v-bind:text="`${material.row.volume.value} ${material.row.volume.unit}`"
              :length="10"
            /> -->
          </template>
        </Table-column>
        <Table-column prop="mrp" :label="`${materialHeaders.mrp} (${currentClient.currency})`" :width="getWidth('tableref','mrp') ? getWidth('tableref','mrp') : 70" columnKey="tableref"></Table-column>
        <Table-column prop="invoiceNumber" :label="materialHeaders.invoice_number" :width="getWidth('tableref','invoiceNumber') ? getWidth('tableref','invoiceNumber') : 150" columnKey="tableref">
          <template slot-scope="material">
            <span v-if="material.row.invoice.otp_status==2" class="cell-icon text-green-medium" style="width: 100%;">
              <Tooltip class="item" effect="dark" :content="`OTP Submitted for ${material.row.invoice.number}`" placement="bottom">
                <span class="text-ellipsis">
                  <svgicon name="icon-tick-sm" class="pointer" width="10" height="10"/>
                  <span class="pointer">{{material.row.invoice.number}}</span>
                </span>
              </Tooltip>
            </span>
            <span v-else>
              <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{material.row.invoice.number}}</div>
                <div class="text-ellipsis pointer">{{material.row.invoice.number}}</div>
              </Tooltip>
              <!-- <Ellipsis v-bind:text="material.row.invoice.number" :length="10" /> -->
            </span>
        </template>
        </Table-column>
        <Table-column prop="invoiceAmount" :label="materialHeaders.invoice_amount" :width="getWidth('tableref','invoiceAmount') ? getWidth('tableref','invoiceAmount') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip v-if="material.row.invoice.amount" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.invoice.amount}}</div>
              <div class="text-ellipsis pointer">{{material.row.invoice.amount}}</div>
            </Tooltip>
            <!-- <Ellipsis
              v-if="material.row.invoice.amount"
              v-bind:text="`${material.row.invoice.amount}`"
              :length="10"
            /> -->
            <span v-else>-</span>
          </template>
        </Table-column>
        <Table-column v-if="materialHeaders.collection_amount" prop="collectionAmount" :label="materialHeaders.collection_amount" :width="getWidth('tableref','collectionAmount') ? getWidth('tableref','collectionAmount') : 100" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip v-if="material.row.invoice.collection_amount" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.invoice.collection_amount}}</div>
              <div class="text-ellipsis pointer">{{material.row.invoice.collection_amount}}</div>
            </Tooltip>
            <span v-else>-</span>
          </template>
        </Table-column>
      <Table-column prop="invoiceDate" :label="materialHeaders.invoice_date" :width="getWidth('tableref','invoiceDate') ? getWidth('tableref','invoiceDate') : 120" columnKey="tableref">
          <template slot-scope="material">
            <span v-if="material.row.invoice.date">
              {{getInvoiceDate(material.row.invoice.date)}}
            </span>
            <span v-else>-</span>
          </template>
        </Table-column>
        <Table-column v-if="materialHeaders.eway_bill_number" prop="ewayBillNumber" :label="materialHeaders.eway_bill_number" :width="getWidth('tableref','ewayBillNumber') ? getWidth('tableref','ewayBillNumber') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip v-if="material.row.eway_bill && material.row.eway_bill.number" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.eway_bill.number}}</div>
              <div class="text-ellipsis pointer">{{material.row.eway_bill.number}}</div>
            </Tooltip>
            <!-- <Ellipsis
              v-if="material.row.eway_bill && material.row.eway_bill.number"
              v-bind:text="`${material.row.eway_bill.number}`"
              :length="10"
            /> -->
            <span v-else>-</span>
          </template>
        </Table-column>
      <Table-column v-if="materialHeaders.eway_bill_date" prop="ewayBillDate" :label="materialHeaders.eway_bill_date" :width="getWidth('tableref','ewayBillDate') ? getWidth('tableref','ewayBillDate') : 100" columnKey="tableref">
          <template slot-scope="material">
            <span v-if="material.row.eway_bill && material.row.eway_bill.date">
              {{material.row.eway_bill.date | moment("DD-MMM-YYYY")}}
            </span>
            <span v-else>-</span>
          </template>
        </Table-column>
        <Table-column prop="pickupPoint" :label="materialHeaders.pickup_point" :width="getWidth('tableref','pickupPoint') ? getWidth('tableref','pickupPoint') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.source_location_reference_id}}</div>
              <div class="text-ellipsis pointer">{{material.row.source_location_reference_id}}</div>
            </Tooltip>
            <!-- <Ellipsis v-bind:text="material.row.source_location_reference_id" :length="10" /> -->
          </template>
        </Table-column>
        <Table-column prop="category" :label="materialHeaders.category" :width="getWidth('tableref','category') ? getWidth('tableref','category') : 100" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.category}}</div>
              <div class="text-ellipsis pointer">{{material.row.category}}</div>
            </Tooltip>
            <!-- <Ellipsis v-bind:text="material.row.category" :length="10" /> -->
          </template>
        </Table-column>
        <Table-column v-if="isInDeliveryState" prop="EPODStatus" label="EPOD status" :width="getWidth('tableref','EPODStatus') ? getWidth('tableref','EPODStatus') : 80" columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.epod.is_submited ? 'Submitted' : 'Not Submitted'}}</div>
              <div class="text-ellipsis pointer">{{material.row.epod.is_submited ? 'Submitted' : 'Not Submitted'}}</div>
            </Tooltip>
            <!-- <Ellipsis v-bind:text="material.row.epod.is_submited ? 'Submitted' : 'Not Submitted'" :length="25" /> -->
          </template>
        </Table-column>
        <Table-column
          v-for="(customfield,index) in materialHeaders.custom_fields"
          :key="index"
          prop="customfield"
          :label="customfield"
          :width="getWidth('tableref','customfield') ? getWidth('tableref','customfield') : ''"
          columnKey="tableref">
          <template slot-scope="material">
            <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
              <div slot="content">{{material.row.custom_fields && material.row.custom_fields[index]}}</div>
              <div class="text-ellipsis pointer">{{material.row.custom_fields && material.row.custom_fields[index]}}</div>
            </Tooltip>
            <!-- <Ellipsis v-bind:text="material.row.custom_fields && material.row.custom_fields[index]" :length="10" /> -->
          </template>
        </Table-column>
        <Table-column v-if="materialHeaders.virtual_pickup_location"
          columnKey="tableref" prop="virtual_pickup_location"
          :label="materialHeaders.virtual_pickup_location"
          :width="getWidth('tableref','pickupPoint') ? getWidth('tableref','pickupPoint') : 80">
            <template slot-scope="material">
              <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{material.row.virtual_pickup_location || '-'}} </div>
                <div class="text-ellipsis pointer">{{material.row.virtual_pickup_location || '-'}} </div>
              </Tooltip>
            </template>
        </Table-column>
        <Table-column v-if="materialHeaders.virtual_shipto_location"
          columnKey="tableref" prop="virtual_shipto_location"
          :label="materialHeaders.virtual_shipto_location"
          :width="getWidth('tableref','pickupPoint') ? getWidth('tableref','pickupPoint') : 80">
            <template slot-scope="material">
              <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{material.row.virtual_shipto_location || '-'}} </div>
                <div class="text-ellipsis pointer">{{material.row.virtual_shipto_location || '-'}} </div>
              </Tooltip>
            </template>
        </Table-column>
        <Table-column v-if="materialHeaders.virtual_soldto_location"
          columnKey="tableref" prop="virtual_soldto_location"
          :label="materialHeaders.virtual_soldto_location"
          :width="getWidth('tableref','pickupPoint') ? getWidth('tableref','pickupPoint') : 80">
            <template slot-scope="material">
              <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{material.row.virtual_soldto_location || '-'}}</div>
                <div class="text-ellipsis pointer">{{material.row.virtual_soldto_location || '-'}} </div>
              </Tooltip>
            </template>
        </Table-column>
        <Table-column
          fixed="right"
          :resizable="false"
          :width="grnHeader.width"
          v-for="(grnHeader,index) in grnHeadersList"
          v-bind:key="grnHeader.id"
          :label="grnHeader.label"
          :class="grnHeader.class"
        >
          <template slot="header" slot-scope="scope">
            <span :class="{'pl-25':index === 0}">{{$t(grnHeader.tlabel)}}</span>
          </template>
          <template slot-scope="scope">
            <TableCell
              :readOnly="
              !canEditGrn ||
              !canEPODEditAble ||
              !$hasPermission('update_grn') ||
              (scope.row.packages && scope.row.packages.length > 0 &&
              canShortageDamageEditable(scope.row.packages[0].id))"
              :isFirstColumn="(index === 0)"
              :movement="orderDetails.movement"
              :index="scope.row.id"
              :header="grnHeader"
              :details="scope.row.epod"
              :material="scope.row.material"
              :quantity="scope.row.quantity"
              :weight="scope.row.weight"
              :mrp="scope.row.mrp"
              :materialCategory="scope.row.material_category"
              :materialSummary="originalMaterialSummaries[scope.row.id]"
            ></TableCell>
          </template>
        </Table-column>
        <Table-column v-if="canShowReturnMaterials"
          :resizable="false"
          fixed="right"
          :width="105"
          :label="$t('RETURN_MATERIAL')"
          class="w100"
        >
          <template slot="header" slot-scope="scope">
            <span :class="{'pl-25':grnHeadersList.length === 0}">{{ $t('RETURN_MATERIAL') }}</span>
          </template>
          <template slot-scope="material">
            <return-materials
              :material="material.row"
              :is-first-column="grnHeadersList.length === 0"
              :unsaved-return-material-details="unsavedReturnMaterialDetails"
              @update-return-count="updateReturnMaterialCount"
            />
          </template>
        </Table-column>
      </Table>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import debounce from 'debounce';
import TableCell from '@/components/orders/documentation/TableCell';
import EpodComment from '@/modules-v2/indent/views/document/epod-comment';
// eslint-disable-next-line import/no-extraneous-dependencies
import { grnHeaders } from '@common/constants/grnConstants';
import TableColMixin from '@common/mixins/TableColMixin';
import moment from 'moment';
import ReturnMaterials from '../../../../../../common-v2/components/ReturnMaterials.vue';

export default {
  components: {
    TableCell,
    EpodComment,
    ReturnMaterials,
  },
  props: ['materialData',
    'originalMaterialSummaries',
    'viewAttachmentsDetailsSlider',
    'canShowGrn',
    'canEditGrn',
    'canEPODEditAble',
    'hasMaterialInvoice',
    'unsavedReturnMaterialDetails',
    'canShowReturnMaterials',
    'editedPackageDetails',
  ],
  mixins: [TableColMixin],
  data() {
    return {
      grnHeaders,
    };
  },
  computed: {
    ...mapGetters({
      orderDetails: 'order/find',
      isOrderLoading: 'order/isOrderLoading',
      materialHeaders: 'order/materialHeaders',
      currentClient: 'app/currentClient',
    }),
    grnHeadersList() {
      if (this.canShowGrn) {
        return this.grnHeaders.filter((grnHeader) => {
          if (grnHeader.name === 'carton_damage') {
            return !this.materialData.isPackage;
          }
          return true;
        });
      }
      return [];
    },
    materialsList() {
      return this.materialData && this.getMaterials(this.materialData.materials);
    },
    isInDeliveryState() {
      return this.orderDetails.status === 23 ||
        this.orderDetails.status === 7 ||
        this.orderDetails.status === 6;
    },
    /**
     * start of epod details
     */

    isDispatched() {
      const orderStatus = this.orderDetails.status;
      return (
        this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus)
      );
    },
    getTableClass() {
      // eslint-disable-next-line no-nested-ternary
      return this.canShowGrn
        ? (this.viewAttachmentsDetailsSlider
          ? 'column-5'
          : 'column-3')
        : 'column-0';
    },
    /**
     * end of epod details
     */

    getWidth() {
      return (tableKey, columnKey) => (this.tableColWidth[tableKey] ? (this.tableColWidth[tableKey][columnKey] ? this.tableColWidth[tableKey][columnKey] : false) : false);
    },
  },
  created() {
    this.setColumnWidth();
  },
  methods: {
    canShortageDamageEditable(packageId) {
      if (this.editedPackageDetails[packageId] && (
        this.editedPackageDetails[packageId].is_package_shortage
      || this.editedPackageDetails[packageId].is_package_damaged)) {
        return true;
      }
      return this.materialData.is_package_damaged || this.materialData.is_package_shortage;
    },
    updateReturnMaterialCount(data) {
      const returnMaterials = { ...this.unsavedReturnMaterialDetails };
      if (Number(data.returnCount) === 0) {
        delete returnMaterials[data.materialId];
      } else {
        returnMaterials[data.materialId] = data.returnCount;
      }
      this.$store.commit('order/UPDATE_RETURN_MATERIALS', returnMaterials);
    },
    getInvoiceDate(invoiceDate) {
      const date = moment(invoiceDate);
      return `${date.utc().format('DD-MMM-YYYY')} ${date.utc().format('HH:mm')}`;
    },
    getDepotDetailParameters(newWidth, oldWidth, column) {
      const modifiedColumn = { ...column };
      modifiedColumn.label = modifiedColumn.property;
      this.setTableParameters(column.columnKey, newWidth, modifiedColumn);
    },

    async confirmDeleteMaterial(material) {
      const result = await this.$PromptConfirm('Are you sure want to delete the selected material ?', 'Delete Material', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      });
      if (result === 'confirm') {
        this.$emit('deleteMaterial', material);
      }
    },

    /**
     * table methods only for highlight row
     */
    currentCell(row, column, cellClick, event) {
      // adding the cell highlight only for right fixed table
      if (column.fixed === 'right') {
        const prevElement = this.$el.getElementsByClassName('cell-highlight')[0];
        if (prevElement != undefined || prevElement != null) {
          prevElement.classList.remove('cell-highlight');
          prevElement.classList.remove('first-cell');
        }
        if (column.label === grnHeaders[0].label) {
          cellClick.classList.add('first-cell');
        }
        cellClick.classList.add('cell-highlight');
        this.topCellClass('cellBorder', cellClick);
      }
    },

    topCellClass(cssName, cell) {
      const firstRow = cell.parentNode.parentNode.firstChild;
      const topCell = firstRow.cells[cell.cellIndex];
      this.removeClassByName('cellBorder');
      topCell.classList.add('cellBorder');
    },
    removeClassByName(cssName) {
      const array = this.$el.getElementsByClassName(cssName);
      for (let i = 0; i < array.length; i += 1) {
        array[i].classList.remove(cssName);
      }
    },
    handlePrev(currentTableIndex = null) {
      this.currentTableIndex = currentTableIndex;
      this.sideScroll('left', 20, 200, 200);
    },
    handleNext(currentTableIndex = null) {
      this.currentTableIndex = currentTableIndex;
      this.sideScroll('right', 20, 200, 200);
    },
    sideScroll: debounce(function debounceScroll(direction, speed, distance, step) {
      let element = this.$refs.tableref.bodyWrapper;
      if (!element) {
        element = this.$refs.tableref[this.currentTableIndex].bodyWrapper;
      }

      if (direction === 'reset') {
        element.scrollLeft = 0;
      } else if (direction === 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
    }, 20),
    /**
     * table methods only for highlight row
     */
    fixTwoDigits(val) {
      const value = val || 0;
      return parseFloat(value.toFixed(2));
    },
    getMaterials(materials) {
      return materials.map(material => ({
        ...material,
        material_code: material.material.code,
        material_name: material.material.name || '',
      }));
    },
    load(material, treeNode, resolve) {
      setTimeout(() => {
        resolve(this.getMaterials(material.children));
      }, 1000);
    },
  },
};
</script>
